// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credit-editor {
  --ce-bg: var(--bg-primary, #f4f7f7);
  --ce-surface: var(--surface-primary, #fff);
  --ce-soft: var(--surface-secondary, #f4f7f7);
  --ce-border: var(--border-subtle, #dce3e2);
  --ce-text: var(--text-primary, #142624);
  --ce-muted: var(--text-secondary, #506360);
  --ce-brand: var(--interactive-default, #0f766e);
  min-height: calc(100vh - 64px);
  margin: 0 -24px -24px;
  background: var(--ce-bg);
  color: var(--ce-text);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.credit-editor * {
  box-sizing: border-box;
}
.credit-editor button,
.credit-editor input,
.credit-editor select,
.credit-editor textarea {
  font: inherit;
}
.credit-editor-topbar {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 32px;
  border-bottom: 1px solid var(--ce-border);
  background: var(--ce-surface);
}
.credit-editor-topbar nav {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ce-muted);
  font-size: 12px;
}
.credit-editor-topbar nav svg {
  width: 14px;
}
.credit-editor-topbar nav strong {
  color: var(--ce-text);
}
.credit-editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 384px;
  width: 100%;
}
.credit-editor-form {
  min-width: 0;
  padding: 28px 32px 36px;
}
.credit-editor-heading h1 {
  margin: 0;
  font-size: var(--font-size-h1, 32px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: var(--line-height-h1, 40px);
  letter-spacing: var(--letter-spacing-h1, -0.48px);
}
.credit-editor-heading p,
.credit-editor-help {
  margin: 5px 0 0;
  color: var(--ce-muted);
  font-size: var(--font-size-caption-md, 13px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-field,
.credit-editor-section {
  margin-top: 24px;
}
.credit-editor label,
.credit-editor-section h2 {
  display: block;
  margin: 0 0 8px;
  font-size: var(--font-size-label-md, 14px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-label-md, 18.2px);
  letter-spacing: var(--letter-spacing-label-md, 0.07px);
}
.credit-editor label small {
  margin-left: 8px;
  padding: 3px 6px;
  border-radius: var(--radius-pill, 999px);
  background: var(--surface-tertiary, #e8edec);
  color: var(--ce-muted);
  font-size: var(--font-size-caption-sm, 12px);
  font-weight: 400;
  line-height: var(--line-height-caption-sm, 16.8px);
  letter-spacing: var(--letter-spacing-caption-sm, 0.12px);
}
.credit-editor input,
.credit-editor select,
.credit-editor textarea {
  width: 100%;
  min-height: 40px;
  border: 1px solid var(--ce-border);
  border-radius: 8px;
  background: var(--ce-surface);
  color: var(--ce-text);
  padding: 9px 12px;
  font-size: var(--font-size-body-sm, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-body-sm, 21.7px);
  letter-spacing: var(--letter-spacing-body-sm, 0);
  outline: 0;
}
.credit-editor input:focus,
.credit-editor select:focus,
.credit-editor textarea:focus {
  border-color: var(--ce-brand);
  box-shadow: none;
}
.credit-editor .credit-editor-dropdown.is-open .quotation-figma-dropdown-trigger,
.credit-editor .credit-editor-dropdown .quotation-figma-dropdown-trigger:focus-visible {
  border-color: var(--ce-brand);
  box-shadow: none;
}
.credit-editor textarea {
  min-height: 76px;
  resize: vertical;
}
.credit-editor-dropdown,
.credit-editor .quotation-figma-dropdown {
  position: relative;
  z-index: 1;
  width: 100%;
}
.credit-editor-dropdown.is-open,
.credit-editor .quotation-figma-dropdown.is-open {
  z-index: 1300;
}
.credit-editor-dropdown .quotation-figma-dropdown-trigger,
.credit-editor .quotation-figma-dropdown-trigger {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 12px;
  border: 1px solid var(--ce-border);
  border-radius: 8px;
  background: var(--ce-surface);
  color: var(--ce-text);
  font-size: var(--font-size-body-sm, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-body-sm, 21.7px);
  letter-spacing: var(--letter-spacing-body-sm, 0);
  text-align: left;
  cursor: pointer;
}
.credit-editor-dropdown .quotation-figma-dropdown-trigger > span {
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.credit-editor-dropdown .quotation-figma-dropdown-trigger > svg {
  position: static;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  color: var(--ce-muted);
  transition: transform var(--duration-fast, 150ms) var(--easing-standard, ease);
}
.credit-editor-dropdown.is-open .quotation-figma-dropdown-trigger > svg {
  transform: rotate(180deg);
}
.credit-editor-dropdown .quotation-figma-dropdown-menu,
.credit-editor .quotation-figma-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  z-index: 1300;
  display: flex;
  width: 100%;
  max-height: 264px;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid var(--ce-border);
  border-radius: 10px;
  border-color: var(--ce-border);
  background: var(--ce-surface);
  box-shadow: var(--elevation-lg, 0 12px 28px rgba(14, 26, 32, 0.16));
}
.credit-editor-dropdown .quotation-figma-dropdown-option,
.credit-editor .quotation-figma-dropdown-option {
  display: flex;
  width: 100%;
  min-height: 36px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--ce-text);
  font-size: var(--font-size-body-sm, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-body-sm, 21.7px);
  letter-spacing: var(--letter-spacing-body-sm, 0);
  text-align: left;
  cursor: pointer;
}
.credit-editor-dropdown .quotation-figma-dropdown-option > span,
.credit-editor .quotation-figma-dropdown-option > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.credit-editor-dropdown .quotation-figma-dropdown-option:hover,
.credit-editor-dropdown .quotation-figma-dropdown-option.is-selected,
.credit-editor .quotation-figma-dropdown-option:hover,
.credit-editor .quotation-figma-dropdown-option.is-selected {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--ce-brand);
}
.credit-editor-error {
  display: block;
  margin-top: 6px;
  color: var(--danger-text, #b42318);
  font-size: var(--font-size-caption-md, 13px);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-context-card {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 14px;
  padding: 14px 16px;
  border: 1px solid var(--ce-border);
  border-radius: 10px;
  background: var(--interactive-soft, #f0f8f7);
  font-size: var(--font-size-caption-md, 13px);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-context-card div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ce-brand);
}
.credit-editor-context-card span {
  color: var(--ce-muted);
}
.credit-editor-section {
  padding-top: 24px;
  border-top: 1px solid var(--ce-border);
}
.credit-editor-section h2 {
  font-size: var(--font-size-label-md, 14px);
}
.credit-lines-table {
  overflow: visible;
  border: 1px solid var(--ce-border);
  border-radius: 10px;
  background: var(--ce-surface);
}
.credit-lines-head,
.credit-line {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 72px 116px 116px 58px;
  align-items: center;
  gap: 8px;
}
.credit-lines-head {
  min-height: 36px;
  padding: 0 10px;
  background: var(--ce-soft);
  color: var(--ce-muted);
  font-size: var(--font-size-label-sm, 12px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-label-sm, 15.6px);
  letter-spacing: var(--letter-spacing-label-sm, 0.12px);
}
.credit-line {
  position: relative;
  padding: 10px;
  border-bottom: 1px solid var(--ce-border);
}
.credit-line:has(.credit-editor-dropdown.is-open) {
  z-index: 10;
}
.credit-line label {
  margin: 0;
}
.credit-line label > span {
  display: none;
}
.credit-line .credit-editor-dropdown {
  display: block;
}
.credit-line .credit-editor-dropdown .quotation-figma-dropdown-trigger {
  height: 34px;
  min-height: 34px;
  padding: 0 9px;
}
.credit-line-description {
  display: none !important;
}
.credit-line input,
.credit-line select {
  min-height: 34px;
  padding: 7px 9px;
  font-size: var(--font-size-body-sm, 14px);
}
.credit-line label:not(:first-child) input {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: 0;
}
.credit-line output {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 7px 9px;
  border-radius: 7px;
  background: var(--ce-soft);
  color: var(--ce-text);
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: var(--font-size-money-md, 16px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-money-md, 20.8px);
  text-align: right;
}
.credit-line button {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid var(--ce-border);
  border-radius: 7px;
  background: var(--ce-surface);
  color: var(--ce-muted);
}
.credit-line button:disabled {
  opacity: 0.4;
}
.credit-lines-total {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-top: 1px solid var(--ce-border);
  font-size: var(--font-size-label-sm, 12px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-label-sm, 15.6px);
  letter-spacing: var(--letter-spacing-label-sm, 0.12px);
}
.credit-lines-total strong {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: var(--font-size-money-md, 16px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-money-md, 20.8px);
  letter-spacing: var(--letter-spacing-money-md, 0);
}
.credit-editor-add-line {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 8px 4px;
  border: 0;
  background: transparent;
  color: var(--ce-brand);
  font-size: var(--font-size-label-sm, 12px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-label-sm, 15.6px);
  letter-spacing: var(--letter-spacing-label-sm, 0.12px);
}
.credit-editor-info,
.credit-editor-preview-note {
  display: flex;
  gap: 9px;
  padding: 12px;
  border: 1px solid var(--info-border, #bfdbfe);
  border-radius: 8px;
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #1d4ed8);
  font-size: var(--font-size-caption-md, 13px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-info svg,
.credit-editor-preview-note svg {
  flex: 0 0 16px;
  margin-top: 1px;
}
.credit-editor-info p {
  margin: 0;
}
.credit-editor-guidance {
  margin: 24px 0 0;
  color: var(--ce-muted);
  font-size: var(--font-size-caption-md, 13px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.credit-editor-actions-bottom {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--ce-border);
}
.credit-editor-button {
  display: inline-flex;
  height: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  border-radius: 10px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  cursor: pointer;
}
.credit-editor-button.secondary {
  border: 1px solid var(--ce-border);
  background: var(--ce-surface);
  color: var(--ce-text);
}
.credit-editor-button.primary {
  border: 1px solid var(--ce-brand);
  background: var(--ce-brand);
  color: var(--on-interactive-primary, #fff);
}
.credit-editor-button.secondary:not(:disabled):hover {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft-hover, #e4f2f0);
  color: var(--ce-text);
}
.credit-editor-button.primary:not(:disabled):hover {
  border-color: var(--interactive-hover, #0c5f59);
  background: var(--interactive-hover, #0c5f59);
  color: var(--on-interactive-primary, #fff);
}
.credit-editor-button.primary:not(:disabled):active {
  border-color: var(--interactive-pressed, #0a4a46);
  background: var(--interactive-pressed, #0a4a46);
}
.credit-editor-button:focus-visible {
  outline: 2px solid var(--focus-ring, #41a89e);
  outline-offset: 2px;
}
.credit-editor-button .MuiCircularProgress-root {
  color: currentColor;
}
.credit-editor-button > svg:not(.MuiCircularProgress-svg) {
  width: 16px;
  height: 16px;
}
.credit-editor-preview {
  padding: 28px 24px;
  border-left: 1px solid var(--ce-border);
  background: var(--ce-soft);
}
.credit-editor-preview h2 {
  margin: 0;
  font-size: var(--font-size-label-md, 14px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-label-md, 18.2px);
  letter-spacing: var(--letter-spacing-label-md, 0.07px);
}
.credit-editor-preview > p {
  margin: 6px 0 18px;
  color: var(--ce-muted);
  font-size: var(--font-size-caption-md, 13px);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-preview-card {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 9px 12px;
  margin-bottom: 14px;
  padding: 16px;
  border: 1px solid var(--ce-border);
  border-radius: 10px;
  background: var(--ce-surface);
  font-size: var(--font-size-caption-md, 13px);
  line-height: var(--line-height-caption-md, 18.2px);
  letter-spacing: var(--letter-spacing-caption-md, 0.065px);
}
.credit-editor-preview-card span {
  color: var(--ce-muted);
}
.credit-editor-preview-card strong {
  text-align: right;
}
.credit-editor-preview-card.totals strong {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: var(--font-size-money-md, 16px);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-money-md, 20.8px);
  letter-spacing: var(--letter-spacing-money-md, 0);
}
.credit-editor-preview-card.totals strong:last-child {
  color: var(--ce-brand);
}
.credit-editor-preview-note {
  border-color: var(--ce-border);
  background: var(--ce-surface);
  color: var(--ce-muted);
}
@media (max-width: 1199px) {
  .credit-editor {
    margin: 0 -16px -24px;
  }
  .credit-editor-topbar {
    display: none;
  }
  .credit-editor-layout {
    grid-template-columns: 1fr;
  }
  .credit-editor-form {
    padding: 24px;
  }
  .credit-editor-preview {
    grid-row: auto;
    padding: 0 24px 24px;
    border-left: 0;
    background: var(--ce-bg);
  }
  .credit-editor-preview > h2,
  .credit-editor-preview > p {
    display: none;
  }
  .credit-editor-preview-card {
    max-width: none;
  }
  .credit-editor-actions-bottom {
    position: sticky;
    bottom: 0;
    z-index: 2;
    margin: 20px -24px -36px;
    padding: 14px 24px;
    background: var(--ce-bg);
  }
}
@media (max-width: 600px) {
  .credit-editor {
    margin: 0 -8px -24px;
  }
  .credit-editor-form {
    padding: 20px 14px 28px;
  }
  .credit-editor-heading h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.36px;
  }
  .credit-editor label,
  .credit-editor-section h2,
  .credit-editor-preview h2 {
    font-size: 13px;
    line-height: 16.9px;
    letter-spacing: 0.065px;
  }
  .credit-editor input,
  .credit-editor select,
  .credit-editor textarea,
  .credit-editor-dropdown .quotation-figma-dropdown-trigger,
  .credit-editor-dropdown .quotation-figma-dropdown-option {
    font-size: 13px;
    line-height: 20.2px;
  }
  .credit-editor-context-card {
    align-items: flex-start;
    flex-direction: column;
  }
  .credit-lines-table {
    border: 0;
    background: transparent;
  }
  .credit-lines-head {
    display: none;
  }
  .credit-line {
    grid-template-columns: 1fr 1fr 36px;
    gap: 9px;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid var(--ce-border);
    border-radius: 10px;
    background: var(--ce-surface);
  }
  .credit-line label:first-child {
    grid-column: 1/4;
  }
  .credit-line label > span {
    display: block;
    margin-bottom: 5px;
    color: var(--ce-muted);
    font-size: 13px;
    font-weight: var(--font-weight-regular, 400);
    line-height: 18.2px;
    letter-spacing: 0.065px;
  }
  .credit-line output {
    align-self: end;
    padding-bottom: 9px;
  }
  .credit-line button {
    align-self: end;
  }
  .credit-lines-total {
    border: 1px solid var(--ce-border);
    border-radius: 8px;
    background: var(--ce-surface);
  }
  .credit-editor-preview {
    padding: 0 14px 18px;
  }
  .credit-editor-actions-bottom {
    display: grid;
    grid-template-columns: 1fr;
    margin: 20px -14px -28px;
    padding: 12px 14px;
  }
  .credit-editor-button {
    width: 100%;
  }
  .credit-editor-guidance {
    line-height: 20.2px;
    letter-spacing: 0;
  }
  .credit-line output {
    font-size: 14px;
    line-height: normal;
  }
  .credit-lines-total strong {
    font-size: 16px;
    line-height: normal;
  }
  .credit-editor-preview-card.totals strong {
    font-size: 14px;
    line-height: normal;
  }
  .credit-editor-preview-card.totals strong:last-child {
    font-size: 16px;
    line-height: 19.5px;
  }
  .credit-editor-actions-top {
    display: none;
  }
}

.credit-editor .credit-line-tax-controls { grid-column: 1 / -1; display: flex; flex-wrap: wrap; gap: var(--space-3); }
.credit-editor .credit-line-tax-controls label { flex: 1 1; min-width: 140px; }
`, "",{"version":3,"sources":["webpack://./src/layouts/CreditNote/CreditNoteEditor.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,4CAA4C;EAC5C,0CAA0C;EAC1C,uCAAuC;EACvC,0CAA0C;EAC1C,+CAA+C;EAC/C,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,6DAA6D;AAC/D;AACA;EACE,sBAAsB;AACxB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,oCAAoC;EACpC,6CAA6C;EAC7C,wCAAwC;EACxC,iDAAiD;AACnD;AACA;;EAEE,eAAe;EACf,sBAAsB;EACtB,4CAA4C;EAC5C,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,sDAAsD;AACxD;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,kDAAkD;EAClD,wDAAwD;AAC1D;AACA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,yCAAyC;EACzC,4CAA4C;EAC5C,+CAA+C;EAC/C,gDAAgD;EAChD,UAAU;AACZ;AACA;;;EAGE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,yCAAyC;EACzC,4CAA4C;EAC5C,+CAA+C;EAC/C,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,8EAA8E;AAChF;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,mEAAmE;AACrE;AACA;;EAEE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,4CAA4C;EAC5C,+CAA+C;EAC/C,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;EAIE,4CAA4C;EAC5C,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,4CAA4C;EAC5C,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;EAEE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,iEAAiE;EACjE,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,iEAAiE;EACjE,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,sDAAsD;AACxD;AACA;EACE,iEAAiE;EACjE,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,sDAAsD;AACxD;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,4CAA4C;EAC5C,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;EAC5C,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,iDAAiD;EACjD,kDAAkD;EAClD,qBAAqB;AACvB;AACA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;AAC5C;AACA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,4CAA4C;EAC5C,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iEAAiE;EACjE,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,iDAAiD;AACnD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,wBAAwB;EAC1B;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;;;IAGE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;EACA;;;;;IAKE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,mCAAmC;IACnC,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,4CAA4C;IAC5C,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C,mBAAmB,EAAE,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACrH,iDAAiD,SAAO,EAAE,gBAAgB,EAAE","sourcesContent":[".credit-editor {\n  --ce-bg: var(--bg-primary, #f4f7f7);\n  --ce-surface: var(--surface-primary, #fff);\n  --ce-soft: var(--surface-secondary, #f4f7f7);\n  --ce-border: var(--border-subtle, #dce3e2);\n  --ce-text: var(--text-primary, #142624);\n  --ce-muted: var(--text-secondary, #506360);\n  --ce-brand: var(--interactive-default, #0f766e);\n  min-height: calc(100vh - 64px);\n  margin: 0 -24px -24px;\n  background: var(--ce-bg);\n  color: var(--ce-text);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.credit-editor * {\n  box-sizing: border-box;\n}\n.credit-editor button,\n.credit-editor input,\n.credit-editor select,\n.credit-editor textarea {\n  font: inherit;\n}\n.credit-editor-topbar {\n  min-height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 32px;\n  border-bottom: 1px solid var(--ce-border);\n  background: var(--ce-surface);\n}\n.credit-editor-topbar nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--ce-muted);\n  font-size: 12px;\n}\n.credit-editor-topbar nav svg {\n  width: 14px;\n}\n.credit-editor-topbar nav strong {\n  color: var(--ce-text);\n}\n.credit-editor-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 384px;\n  width: 100%;\n}\n.credit-editor-form {\n  min-width: 0;\n  padding: 28px 32px 36px;\n}\n.credit-editor-heading h1 {\n  margin: 0;\n  font-size: var(--font-size-h1, 32px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: var(--line-height-h1, 40px);\n  letter-spacing: var(--letter-spacing-h1, -0.48px);\n}\n.credit-editor-heading p,\n.credit-editor-help {\n  margin: 5px 0 0;\n  color: var(--ce-muted);\n  font-size: var(--font-size-caption-md, 13px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-field,\n.credit-editor-section {\n  margin-top: 24px;\n}\n.credit-editor label,\n.credit-editor-section h2 {\n  display: block;\n  margin: 0 0 8px;\n  font-size: var(--font-size-label-md, 14px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-label-md, 18.2px);\n  letter-spacing: var(--letter-spacing-label-md, 0.07px);\n}\n.credit-editor label small {\n  margin-left: 8px;\n  padding: 3px 6px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--ce-muted);\n  font-size: var(--font-size-caption-sm, 12px);\n  font-weight: 400;\n  line-height: var(--line-height-caption-sm, 16.8px);\n  letter-spacing: var(--letter-spacing-caption-sm, 0.12px);\n}\n.credit-editor input,\n.credit-editor select,\n.credit-editor textarea {\n  width: 100%;\n  min-height: 40px;\n  border: 1px solid var(--ce-border);\n  border-radius: 8px;\n  background: var(--ce-surface);\n  color: var(--ce-text);\n  padding: 9px 12px;\n  font-size: var(--font-size-body-sm, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-body-sm, 21.7px);\n  letter-spacing: var(--letter-spacing-body-sm, 0);\n  outline: 0;\n}\n.credit-editor input:focus,\n.credit-editor select:focus,\n.credit-editor textarea:focus {\n  border-color: var(--ce-brand);\n  box-shadow: none;\n}\n.credit-editor .credit-editor-dropdown.is-open .quotation-figma-dropdown-trigger,\n.credit-editor .credit-editor-dropdown .quotation-figma-dropdown-trigger:focus-visible {\n  border-color: var(--ce-brand);\n  box-shadow: none;\n}\n.credit-editor textarea {\n  min-height: 76px;\n  resize: vertical;\n}\n.credit-editor-dropdown,\n.credit-editor .quotation-figma-dropdown {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n}\n.credit-editor-dropdown.is-open,\n.credit-editor .quotation-figma-dropdown.is-open {\n  z-index: 1300;\n}\n.credit-editor-dropdown .quotation-figma-dropdown-trigger,\n.credit-editor .quotation-figma-dropdown-trigger {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 0 12px;\n  border: 1px solid var(--ce-border);\n  border-radius: 8px;\n  background: var(--ce-surface);\n  color: var(--ce-text);\n  font-size: var(--font-size-body-sm, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-body-sm, 21.7px);\n  letter-spacing: var(--letter-spacing-body-sm, 0);\n  text-align: left;\n  cursor: pointer;\n}\n.credit-editor-dropdown .quotation-figma-dropdown-trigger > span {\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.credit-editor-dropdown .quotation-figma-dropdown-trigger > svg {\n  position: static;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  color: var(--ce-muted);\n  transition: transform var(--duration-fast, 150ms) var(--easing-standard, ease);\n}\n.credit-editor-dropdown.is-open .quotation-figma-dropdown-trigger > svg {\n  transform: rotate(180deg);\n}\n.credit-editor-dropdown .quotation-figma-dropdown-menu,\n.credit-editor .quotation-figma-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  left: 0;\n  z-index: 1300;\n  display: flex;\n  width: 100%;\n  max-height: 264px;\n  flex-direction: column;\n  gap: 2px;\n  overflow-y: auto;\n  padding: 6px;\n  border: 1px solid var(--ce-border);\n  border-radius: 10px;\n  border-color: var(--ce-border);\n  background: var(--ce-surface);\n  box-shadow: var(--elevation-lg, 0 12px 28px rgba(14, 26, 32, 0.16));\n}\n.credit-editor-dropdown .quotation-figma-dropdown-option,\n.credit-editor .quotation-figma-dropdown-option {\n  display: flex;\n  width: 100%;\n  min-height: 36px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--ce-text);\n  font-size: var(--font-size-body-sm, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-body-sm, 21.7px);\n  letter-spacing: var(--letter-spacing-body-sm, 0);\n  text-align: left;\n  cursor: pointer;\n}\n.credit-editor-dropdown .quotation-figma-dropdown-option > span,\n.credit-editor .quotation-figma-dropdown-option > span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.credit-editor-dropdown .quotation-figma-dropdown-option:hover,\n.credit-editor-dropdown .quotation-figma-dropdown-option.is-selected,\n.credit-editor .quotation-figma-dropdown-option:hover,\n.credit-editor .quotation-figma-dropdown-option.is-selected {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--ce-brand);\n}\n.credit-editor-error {\n  display: block;\n  margin-top: 6px;\n  color: var(--danger-text, #b42318);\n  font-size: var(--font-size-caption-md, 13px);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-context-card {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 14px;\n  padding: 14px 16px;\n  border: 1px solid var(--ce-border);\n  border-radius: 10px;\n  background: var(--interactive-soft, #f0f8f7);\n  font-size: var(--font-size-caption-md, 13px);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-context-card div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--ce-brand);\n}\n.credit-editor-context-card span {\n  color: var(--ce-muted);\n}\n.credit-editor-section {\n  padding-top: 24px;\n  border-top: 1px solid var(--ce-border);\n}\n.credit-editor-section h2 {\n  font-size: var(--font-size-label-md, 14px);\n}\n.credit-lines-table {\n  overflow: visible;\n  border: 1px solid var(--ce-border);\n  border-radius: 10px;\n  background: var(--ce-surface);\n}\n.credit-lines-head,\n.credit-line {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) 72px 116px 116px 58px;\n  align-items: center;\n  gap: 8px;\n}\n.credit-lines-head {\n  min-height: 36px;\n  padding: 0 10px;\n  background: var(--ce-soft);\n  color: var(--ce-muted);\n  font-size: var(--font-size-label-sm, 12px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-label-sm, 15.6px);\n  letter-spacing: var(--letter-spacing-label-sm, 0.12px);\n}\n.credit-line {\n  position: relative;\n  padding: 10px;\n  border-bottom: 1px solid var(--ce-border);\n}\n.credit-line:has(.credit-editor-dropdown.is-open) {\n  z-index: 10;\n}\n.credit-line label {\n  margin: 0;\n}\n.credit-line label > span {\n  display: none;\n}\n.credit-line .credit-editor-dropdown {\n  display: block;\n}\n.credit-line .credit-editor-dropdown .quotation-figma-dropdown-trigger {\n  height: 34px;\n  min-height: 34px;\n  padding: 0 9px;\n}\n.credit-line-description {\n  display: none !important;\n}\n.credit-line input,\n.credit-line select {\n  min-height: 34px;\n  padding: 7px 9px;\n  font-size: var(--font-size-body-sm, 14px);\n}\n.credit-line label:not(:first-child) input {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  font-weight: var(--font-weight-medium, 500);\n  letter-spacing: 0;\n}\n.credit-line output {\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 7px 9px;\n  border-radius: 7px;\n  background: var(--ce-soft);\n  color: var(--ce-text);\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: var(--font-size-money-md, 16px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-money-md, 20.8px);\n  text-align: right;\n}\n.credit-line button {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  border: 1px solid var(--ce-border);\n  border-radius: 7px;\n  background: var(--ce-surface);\n  color: var(--ce-muted);\n}\n.credit-line button:disabled {\n  opacity: 0.4;\n}\n.credit-lines-total {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 12px;\n  border-top: 1px solid var(--ce-border);\n  font-size: var(--font-size-label-sm, 12px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-label-sm, 15.6px);\n  letter-spacing: var(--letter-spacing-label-sm, 0.12px);\n}\n.credit-lines-total strong {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: var(--font-size-money-md, 16px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-money-md, 20.8px);\n  letter-spacing: var(--letter-spacing-money-md, 0);\n}\n.credit-editor-add-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 8px 4px;\n  border: 0;\n  background: transparent;\n  color: var(--ce-brand);\n  font-size: var(--font-size-label-sm, 12px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-label-sm, 15.6px);\n  letter-spacing: var(--letter-spacing-label-sm, 0.12px);\n}\n.credit-editor-info,\n.credit-editor-preview-note {\n  display: flex;\n  gap: 9px;\n  padding: 12px;\n  border: 1px solid var(--info-border, #bfdbfe);\n  border-radius: 8px;\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #1d4ed8);\n  font-size: var(--font-size-caption-md, 13px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-info svg,\n.credit-editor-preview-note svg {\n  flex: 0 0 16px;\n  margin-top: 1px;\n}\n.credit-editor-info p {\n  margin: 0;\n}\n.credit-editor-guidance {\n  margin: 24px 0 0;\n  color: var(--ce-muted);\n  font-size: var(--font-size-caption-md, 13px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.credit-editor-actions-bottom {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid var(--ce-border);\n}\n.credit-editor-button {\n  display: inline-flex;\n  height: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n.credit-editor-button.secondary {\n  border: 1px solid var(--ce-border);\n  background: var(--ce-surface);\n  color: var(--ce-text);\n}\n.credit-editor-button.primary {\n  border: 1px solid var(--ce-brand);\n  background: var(--ce-brand);\n  color: var(--on-interactive-primary, #fff);\n}\n.credit-editor-button.secondary:not(:disabled):hover {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft-hover, #e4f2f0);\n  color: var(--ce-text);\n}\n.credit-editor-button.primary:not(:disabled):hover {\n  border-color: var(--interactive-hover, #0c5f59);\n  background: var(--interactive-hover, #0c5f59);\n  color: var(--on-interactive-primary, #fff);\n}\n.credit-editor-button.primary:not(:disabled):active {\n  border-color: var(--interactive-pressed, #0a4a46);\n  background: var(--interactive-pressed, #0a4a46);\n}\n.credit-editor-button:focus-visible {\n  outline: 2px solid var(--focus-ring, #41a89e);\n  outline-offset: 2px;\n}\n.credit-editor-button .MuiCircularProgress-root {\n  color: currentColor;\n}\n.credit-editor-button > svg:not(.MuiCircularProgress-svg) {\n  width: 16px;\n  height: 16px;\n}\n.credit-editor-preview {\n  padding: 28px 24px;\n  border-left: 1px solid var(--ce-border);\n  background: var(--ce-soft);\n}\n.credit-editor-preview h2 {\n  margin: 0;\n  font-size: var(--font-size-label-md, 14px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-label-md, 18.2px);\n  letter-spacing: var(--letter-spacing-label-md, 0.07px);\n}\n.credit-editor-preview > p {\n  margin: 6px 0 18px;\n  color: var(--ce-muted);\n  font-size: var(--font-size-caption-md, 13px);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-preview-card {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 9px 12px;\n  margin-bottom: 14px;\n  padding: 16px;\n  border: 1px solid var(--ce-border);\n  border-radius: 10px;\n  background: var(--ce-surface);\n  font-size: var(--font-size-caption-md, 13px);\n  line-height: var(--line-height-caption-md, 18.2px);\n  letter-spacing: var(--letter-spacing-caption-md, 0.065px);\n}\n.credit-editor-preview-card span {\n  color: var(--ce-muted);\n}\n.credit-editor-preview-card strong {\n  text-align: right;\n}\n.credit-editor-preview-card.totals strong {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: var(--font-size-money-md, 16px);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-money-md, 20.8px);\n  letter-spacing: var(--letter-spacing-money-md, 0);\n}\n.credit-editor-preview-card.totals strong:last-child {\n  color: var(--ce-brand);\n}\n.credit-editor-preview-note {\n  border-color: var(--ce-border);\n  background: var(--ce-surface);\n  color: var(--ce-muted);\n}\n@media (max-width: 1199px) {\n  .credit-editor {\n    margin: 0 -16px -24px;\n  }\n  .credit-editor-topbar {\n    display: none;\n  }\n  .credit-editor-layout {\n    grid-template-columns: 1fr;\n  }\n  .credit-editor-form {\n    padding: 24px;\n  }\n  .credit-editor-preview {\n    grid-row: auto;\n    padding: 0 24px 24px;\n    border-left: 0;\n    background: var(--ce-bg);\n  }\n  .credit-editor-preview > h2,\n  .credit-editor-preview > p {\n    display: none;\n  }\n  .credit-editor-preview-card {\n    max-width: none;\n  }\n  .credit-editor-actions-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n    margin: 20px -24px -36px;\n    padding: 14px 24px;\n    background: var(--ce-bg);\n  }\n}\n@media (max-width: 600px) {\n  .credit-editor {\n    margin: 0 -8px -24px;\n  }\n  .credit-editor-form {\n    padding: 20px 14px 28px;\n  }\n  .credit-editor-heading h1 {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n  }\n  .credit-editor label,\n  .credit-editor-section h2,\n  .credit-editor-preview h2 {\n    font-size: 13px;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n  }\n  .credit-editor input,\n  .credit-editor select,\n  .credit-editor textarea,\n  .credit-editor-dropdown .quotation-figma-dropdown-trigger,\n  .credit-editor-dropdown .quotation-figma-dropdown-option {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n  .credit-editor-context-card {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .credit-lines-table {\n    border: 0;\n    background: transparent;\n  }\n  .credit-lines-head {\n    display: none;\n  }\n  .credit-line {\n    grid-template-columns: 1fr 1fr 36px;\n    gap: 9px;\n    margin-bottom: 10px;\n    padding: 10px;\n    border: 1px solid var(--ce-border);\n    border-radius: 10px;\n    background: var(--ce-surface);\n  }\n  .credit-line label:first-child {\n    grid-column: 1/4;\n  }\n  .credit-line label > span {\n    display: block;\n    margin-bottom: 5px;\n    color: var(--ce-muted);\n    font-size: 13px;\n    font-weight: var(--font-weight-regular, 400);\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n  }\n  .credit-line output {\n    align-self: end;\n    padding-bottom: 9px;\n  }\n  .credit-line button {\n    align-self: end;\n  }\n  .credit-lines-total {\n    border: 1px solid var(--ce-border);\n    border-radius: 8px;\n    background: var(--ce-surface);\n  }\n  .credit-editor-preview {\n    padding: 0 14px 18px;\n  }\n  .credit-editor-actions-bottom {\n    display: grid;\n    grid-template-columns: 1fr;\n    margin: 20px -14px -28px;\n    padding: 12px 14px;\n  }\n  .credit-editor-button {\n    width: 100%;\n  }\n  .credit-editor-guidance {\n    line-height: 20.2px;\n    letter-spacing: 0;\n  }\n  .credit-line output {\n    font-size: 14px;\n    line-height: normal;\n  }\n  .credit-lines-total strong {\n    font-size: 16px;\n    line-height: normal;\n  }\n  .credit-editor-preview-card.totals strong {\n    font-size: 14px;\n    line-height: normal;\n  }\n  .credit-editor-preview-card.totals strong:last-child {\n    font-size: 16px;\n    line-height: 19.5px;\n  }\n  .credit-editor-actions-top {\n    display: none;\n  }\n}\n\n.credit-editor .credit-line-tax-controls { grid-column: 1 / -1; display: flex; flex-wrap: wrap; gap: var(--space-3); }\n.credit-editor .credit-line-tax-controls label { flex: 1; min-width: 140px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
